'use strict';

export default class AdminController {
  /*@ngInject*/
  newUser = {
    name: '',
    email: '',
    role: 'user',
    password: ''
  };
  errors = {
    createUser: undefined
  };

  constructor(User, Auth, $state) {
    // Use the User $resource to fetch all users
    this._Auth = Auth;
    this._$state = $state;
    this.users = User.query();
    console.log(this.users);
  }

  delete(user) {
    user.$remove();
    this.users.splice(this.users.indexOf(user), 1);
  }

  createUser(form) {
    this.submitted = true;
    console.log(form);
    if(form.$valid) {
      this._Auth.createUser(this.newUser)
        .then(user => {
          console.log(user);
          this._$state.go('main');
        })
        .catch(err => {
          console.log(err);
          this.errors.createUser = err.data.message;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin.controller.js